import {
  DetailsSidebar,
  DetailsSidebarProvider,
  DetailsSidebarTrigger,
  Footer,
  Stack,
} from '@eluve/components';
import { useIsAppointmentSigned } from '@eluve/frontend-appointment-hooks';
import { useTranslation } from '@eluve/i18n';

import { AppointmentLastSaved } from './AppointmentLastSaved';
import { AppointmentPDFOutputControls } from './AppointmentPDFOutputControls';
import { SignAndSyncAppointmentButton } from './SignAndSyncAppointmentButton';
import { SignedSummaryFooter } from './SignedSummaryFooter';
import { VersionHistorySidebar } from './VersionHistorySidebar';

export const AppointmentSummaryFooter: React.FC = () => {
  const { t } = useTranslation();
  const isAppointmentSigned = useIsAppointmentSigned();
  return (
    <Footer>
      <Stack
        justify="between"
        gap={1}
        className="mx-auto max-w-5xl px-2"
        direction="horizontal"
      >
        <DetailsSidebarProvider overlayOnly>
          <DetailsSidebar
            title={t('appointmentPage.versionHistory.title')}
            size="md"
          >
            <VersionHistorySidebar />
          </DetailsSidebar>
          <DetailsSidebarTrigger>
            <AppointmentLastSaved />
          </DetailsSidebarTrigger>
        </DetailsSidebarProvider>

        <Stack fullWidth={false} gap={2} direction="horizontal">
          {isAppointmentSigned ? (
            <SignedSummaryFooter />
          ) : (
            <>
              <AppointmentPDFOutputControls />
              <SignAndSyncAppointmentButton />
            </>
          )}
        </Stack>
      </Stack>
    </Footer>
  );
};
